module.exports = __webpack_public_path__ + "img/685103.9d129ce6.svg";